/**
 * Name of awareness event.
 */
export enum AwarenessEventName {
  TagAlarm = 'TagAlarm'
}